import { IEstimationCategory } from '@shared/types/estimation_category';
import { IEstimationSelection } from '@shared/types/estimation_selection';

interface IEstimationSelectionAttribute {
  id?: string;
  estimation_category_id: string;
  quantity?: number;
  selected?: boolean;
}

export const buildEstimationSelectionsAttributes = (data?: Map<IEstimationCategory, Partial<IEstimationSelection>>) => {
  const results: IEstimationSelectionAttribute[] = [];
  if (!data) {
    return results;
  }

  for (const category of Array.from(data.keys())) {
    const selection = data.get(category);
    if (!selection) {
      continue;
    }
    results.push({
      id: selection.id,
      estimation_category_id: category.id,
      quantity: selection.quantity,
      selected: selection.selected,
    });
  }

  return results;
};
